// test924
(924 && 0);
